<template>
    <div class="input-content" :class="{ 'input-focused': inputFocused, 'error-state': errorState }">
        <input
        class="input-otp"
        :autocomplete="applyAutoCompleteOneTime ? 'one-time-code' : null"
        :value="value"
        :inputmode="getDeviceInUse === 'ios' ? 'decimal' : 'numeric'"
        :class="{'ios-input': getDeviceInUse === 'ios' }"
		@input="handleInput"
		@keyup="checkIfReturnMobileClick"
        @keydown.backspace="emit('backspaceHandler', $event)"
        @paste.prevent.stop="emit('pasteData', $event)"
        @focus="[emit('onFocus', $event), inputFocused = true]"
        @blur="[emit('onBlur', $event), inputFocused = false]"/>
    </div>
</template>

<script setup>
/* Vue Imports */
import { ref, watch } from 'vue'
/* Store */
import { storeToRefs } from 'pinia'
import { useProjectBaseStore } from '@/store/projectBase'
const { getDeviceInUse } = storeToRefs(useProjectBaseStore())

/* Emmitters */
const emit = defineEmits(['backspaceHandler', 'inputPositionChanged', 'pasteData', 'onFocus', 'onBlur'])

/* Props
@applyAutoCompleteOneTime
@value {Number}
@errorState {Boolean}
*/
const props = defineProps({
	applyAutoCompleteOneTime: Boolean,
    value: Number,
    errorState: Boolean,
    params: Object
})

const inputFocused = ref(false)

const checkIfReturnMobileClick = $event => {
	if ($event.which === 13) document.activeElement.blur()
}

const handleInput = (event) => {
	const inputDigit = event.data

	if (inputDigit && !/^[0-9]+$/.test(inputDigit)) {
		event.target.value = event.target.value.replace(/\D/g, '')
		return
	}

	emit('inputPositionChanged', inputDigit)
}
</script>

<style lang="scss" scoped>
.input-content {
    width: 61px;
    height: 56px;
    position: relative;

    flex-shrink: 0;

    @include H6-Regular;
    line-height: 18px;

    border: 1px solid var(--secondary-light-1);
    border-radius: 8px;

    background-color: var(--secondary-light-4);

    input {
        width: 100%;
        height: 100%;

        text-align: center;
        color: var(--secondary-dark-3);

        box-sizing: border-box;
        background-color:transparent;
        outline: none;
        border: none;
        resize: none;

        &::placeholder {
            opacity: 1;
            /* For firefox */
            @include H7-Regular;
            line-height: 18px;
            color: var(--secondary);
        }

        &::-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            @include H7-Regular;
            line-height: 18px;
            color: var(--secondary);
        }

        &::-ms-input-placeholder {
            /* Microsoft Edge */
            @include H7-Regular;
            line-height: 18px;
            color: var(--secondary);
        }

        &.apply-dark-background-variant {
            color: var(--white);
        }
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            border-color: var(--secondary-dark-3);
        }
    }

    &:active {
        background-color: var(--secondary-light-4);
    }

    &.input-focused {
        border-color: var(--primary);
    }

    &.error-state {
        border-color: var(--negative);
    }
}
</style>
